
export function ethWalletFormat(value: string) {
    return value && chopIt(value, 6) + value.slice(-4);
}

export function chopIt(value: string, max: number) {
    return (value?.length > max ? value.slice(0, max)+'...' : value);
}